import { Check, ChevronsUpDown } from 'lucide-react';
import { useState } from 'react';

import { cn } from '~shared/shadcn/lib/utils';
import { Button } from '~shared/shadcn/ui/button';
import {
  Command,
  CommandEmpty,
  CommandGroup,
  CommandInput,
  CommandItem,
  CommandList,
} from '~shared/shadcn/ui/command';
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from '~shared/shadcn/ui/popover';

interface StudentLastNameFilterProps {
  lastNames: Array<string>;
  value: string;
  onValueChange: React.Dispatch<React.SetStateAction<string>>;
}

export function StudentLastNameFilter({
  lastNames,
  value,
  onValueChange,
}: StudentLastNameFilterProps) {
  const [open, setOpen] = useState(false);

  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <Button
          variant='outline'
          role='combobox'
          aria-expanded={open}
          className='w-[200px] justify-between capitalize'
        >
          {value
            ? lastNames.find((lastName) => lastName === value)
            : 'Student Last Names'}
          <ChevronsUpDown className='opacity-50' />
        </Button>
      </PopoverTrigger>
      <PopoverContent className='w-[200px] p-0'>
        <Command>
          <CommandInput placeholder='Search last name...' />
          <CommandList>
            <CommandEmpty>No last name found.</CommandEmpty>
            <CommandGroup>
              {lastNames.map((lastName) => (
                <CommandItem
                  key={lastName}
                  value={lastName}
                  onSelect={(currentValue) => {
                    onValueChange(currentValue === value ? '' : currentValue);
                    setOpen(false);
                  }}
                  className='capitalize'
                >
                  {lastName}
                  <Check
                    className={cn(
                      'ml-auto',
                      value === lastName ? 'opacity-100' : 'opacity-0',
                    )}
                  />
                </CommandItem>
              ))}
            </CommandGroup>
          </CommandList>
        </Command>
      </PopoverContent>
    </Popover>
  );
}
